module.exports = __webpack_public_path__ + "static/img/1667303170833444.cb7bbde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/energy/1667303170833444.jpg
// module id = y0la
// module chunks = 4